import { render, staticRenderFns } from "./FeedbackChart.vue?vue&type=template&id=597b7f41&"
import script from "./FeedbackChart.vue?vue&type=script&lang=js&"
export * from "./FeedbackChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports